<script>
  import { onMount } from 'svelte'
  import parseHostname from '@ta-interaktiv/parse-hostname'
  import NewCasesSwitzerland from './NewCasesSwitzerland.svelte'
  import Vaccination from './Vaccination.svelte'
  import DeathsWorldwide from './DeathsWorldwide.svelte'

  let innerWidth = 0
  let data

  const hostname = parseHostname()

  $: isMobile = innerWidth < 665

  onMount(async () => {
    const basicData = await fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/corona-dashboard-mini-basic.json'
    ).then(d => d.json())
    if (isMobile) {
      data = basicData
    } else {
      const extendedData = await fetch(
        'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/corona-dashboard-mini-extended.json'
      ).then(d => d.json())
      data = extendedData
    }
  })
</script>

<style>
  main {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 28px;
  }

  .link {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  main > div {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  @media only screen and (min-width: 1024px){
    main {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media only screen and (min-width: 665px) and (max-width: 1023px) {
    main {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media only screen and (max-width: 665px) {
    main {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
    }
    main > div {
      grid-column-start: 1;
      grid-column-end: 2;
    }
  }
</style>

<svelte:window bind:innerWidth />

<main>
  {#if data}
    <div>
      <NewCasesSwitzerland {isMobile} data={data.switzerland} />
    </div>
    <!-- {#if !isMobile}
      <Vaccination data={data.vaccination} />
      <DeathsWorldwide data={data.world} />
    {/if} -->
  {/if}
  <a class="link" href={`//${hostname.publicationDomain}/18727947?utm_source=mini-dashboard`}></a>
</main>
